import { useTranslation } from 'react-i18next';
import { commonDescendingComparator, getPrettyRole, getPrettySections, getUserPreferredFullName } from 'utils/helper';

export const usePeopleTableColumns = () => {
    const { t } = useTranslation();
    return [
        {
            id: 'name',
            columnTitle: t('table.name', 'Name'),
            isFixed: true,
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => getUserPreferredFullName(item);

                return [...items].sort((a, b) => {
                    return order === 'desc'
                        ? commonDescendingComparator(a, b, getter)
                        : -commonDescendingComparator(a, b, getter);
                });
            },
        },
        {
            id: 'email',
            columnTitle: t('table.email', 'Email'),
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => item.email;

                return [...items].sort((a, b) => {
                    return order === 'desc'
                        ? commonDescendingComparator(a, b, getter)
                        : -commonDescendingComparator(a, b, getter);
                });
            },
        },
        {
            id: 'role',
            columnTitle: t('table.role', 'Role'),
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => getPrettyRole(item.role, t);

                return [...items].sort((a, b) => {
                    return order === 'desc'
                        ? commonDescendingComparator(a, b, getter)
                        : -commonDescendingComparator(a, b, getter);
                });
            },
        },
        {
            id: 'sections',
            columnTitle: t('table.section-s', 'Section(s)'),
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => getPrettySections(item.sections);

                return [...items].sort((a, b) => {
                    return order === 'desc'
                        ? commonDescendingComparator(a, b, getter)
                        : -commonDescendingComparator(a, b, getter);
                });
            },
        },
        {
            id: 'last_activity',
            columnTitle: t('table.last-activity', 'Last Activity'),
            ascSuffix: '(asc)',
            descSuffix: '(desc)',
            comparator: (order, items) => {
                if (!order) return items;

                const getter = (item) => (item.login_activity ? item.login_activity.created_on : 0);

                return [...items].sort((a, b) => {
                    return order === 'desc'
                        ? commonDescendingComparator(a, b, getter)
                        : -commonDescendingComparator(a, b, getter);
                });
            },
        },
    ];
};
